export class ScriptLoader {
  constructor() {
    if (typeof window.scriptLoader !== 'undefined') return window.scriptLoader;
    window.scriptLoader = this;
    this.loadedScripts = new Set(); // Хранение загруженных скриптов
  }

  loadScript(url) {
    // Нормализация URL, чтобы избежать дублирования
    const normalizedUrl = url.replace(/\/$/, ''); // Удаление завершающего слэша, если он есть

    return new Promise((resolve, reject) => {
      if (!this.loadedScripts.has(normalizedUrl)) {
        this.loadedScripts.add(normalizedUrl); // Добавляем URL в Set сразу, чтобы избежать повторных загрузок

        ajax({
          url: normalizedUrl,
          dataType: 'script',
          cache: true,
          success: () => {
            resolve(`Script loaded: ${normalizedUrl}`);
          },
          error: () => {
            this.loadedScripts.delete(normalizedUrl); // Удалить из Set в случае ошибки загрузки
            reject(`Failed to load script: ${normalizedUrl}`);
          }
        });
      } else {
        resolve(`Script already loaded: ${normalizedUrl}`);
      }
    });
  }
}
